import React from 'react'
import { useTranslation } from 'react-i18next'
// ANTD
import { Col, Row } from 'antd';
import { AlertBox, SelectInput, TextInput } from '@life-line-lab/components-react';
// types
import { UserCreationInput } from 'Types/user.types';

interface PaymentDetailsProps {
    input: UserCreationInput;
    error: any;
    onTextInputChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSelectInputChange?: (value: string | string[], name: string) => void;
}

const PaymentDetails: React.FC<PaymentDetailsProps> = ({
    input,
    error,
    onTextInputChange,
    onSelectInputChange,
}) => {

    const bankList = [
        {
            label: "Maybank",
            value: "Maybank",
        },
        {
            label: "CIMB Bank",
            value: "CIMB Bank",
        },
        {
            label: "RHB Bank",
            value: "RHB Bank",
        },
        {
            label: "Bank Islam",
            value: "Bank Islam",
        },
        {
            label: "Bank Muamalat",
            value: "Bank Muamalat",
        },
        {
            label: "Bank Rakyat",
            value: "Bank Rakyat",
        },
        {
            label: "Bank Simpanan Nasional",
            value: "Bank Simpanan Nasional",
        },
        {
            label: "Citibank",
            value: "Citibank",
        },
        {
            label: "Hong Leong Bank",
            value: "Hong Leong Bank",
        },
        {
            label: "HSBC Bank",
            value: "HSBC Bank",
        },
        {
            label: "OCBC Bank",
            value: "OCBC Bank",
        },
        {
            label: "Public Bank",
            value: "Public Bank",
        },
        {
            label: "Affin Bank",
            value: "Affin Bank",
        },
        {
            label: "AmBank",
            value: "AmBank",
        },
        {
            label: "Agro Bank",
            value: "Agro Bank",
        },
        {
            label: "Alliance Bank",
            value: "Alliance Bank",
        },
        {
            label: "Al-Rajhi Bank",
            value: "Al-Rajhi Bank",
        },
        {
            label: "Bank of China",
            value: "Bank of China",
        },
        {
            label: "Bank of America",
            value: "Bank of America",
        },
        {
            label: "Bank of Tokyo-Mitsubishi UFJ",
            value: "Bank of Tokyo-Mitsubishi UFJ",
        },
        {
            label: "BNP Paribas",
            value: "BNP Paribas",
        },
        {
            label: "Deutsche Bank",
            value: "Deutsche Bank",
        },
        {
            label: "Industrial & Commercial Bank of China",
            value: "Industrial & Commercial Bank of China",
        },
        {
            label: "JP Morgan Chase Bank",
            value: "JP Morgan Chase Bank",
        },
        {
            label: "Kuwait Finance House",
            value: "Kuwait Finance House",
        },
        {
            label: "Mizuho Bank",
            value: "Mizuho Bank",
        },
        {
            label: "Standard Chartered Bank",
            value: "Standard Chartered Bank",
        },
        {
            label: "Sumitomo Mitsui Banking Corporation",
            value: "Sumitomo Mitsui Banking Corporation",
        },
        {
            label: "The Royal Bank of Scotland",
            value: "The Royal Bank of Scotland",
        },
        {
            label: "United Overseas Bank",
            value: "United Overseas Bank",
        }
    ];
    const { t } = useTranslation();

    return (
        <React.Fragment>
            {
                input.id ? null :
                    <div className="center header-title">
                        {t("title.paymentDetails").toUpperCase()}
                    </div>
            }
            <Row gutter={[15, 15]} className="mt-50">
                <Col xs={24} sm={24} md={12}>
                    <SelectInput
                        showSearch
                        options={bankList}
                        filterOption={(inputValue, option) =>
                            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        }
                        value={input.bankType}
                        name="bankType"
                        label={t("label.bankType")}
                        placeholder={t('option.bank')}
                        onChange={
                            (value: string | string[]) => {
                                onSelectInputChange &&
                                    onSelectInputChange(value, 'bankType')
                            }
                        }
                    />
                    <AlertBox text={error.bankType} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.accountNumber")}
                        placeholder={t("txt.accountNumber")}
                        value={input.accountNo}
                        name="accountNo"
                        onChange={onTextInputChange}
                    />
                    <AlertBox text={error.accountNo} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.socsoNo")}
                        value={input.socsoNo}
                        name="socsoNo"
                        onChange={onTextInputChange}
                    />
                    <AlertBox text={error.socsoNo} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.epfNo")}
                        value={input.epfNo}
                        name="epfNo"
                        onChange={onTextInputChange}
                    />
                    <AlertBox text={error.epfNo} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.incomeTax")}
                        value={input.incomeTax}
                        name="incomeTax"
                        onChange={onTextInputChange}
                    />
                    <AlertBox text={error.incomeTax} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.hrdfNo")}
                        value={input.hrdfNo}
                        name="hrdfNo"
                        onChange={onTextInputChange}
                    />
                    <AlertBox text={error.hrdfNo} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.zakatNo")}
                        value={input.zakatNo}
                        name="zakatNo"
                        onChange={onTextInputChange}
                    />
                    <AlertBox text={error.zakatNo} />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default PaymentDetails